/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="70.67"
        viewBox="0 0 95.58 70.67"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M56.33 28.9a1.25 1.25 0 0 1 1.24 1.1v25.68a1.26 1.26 0 0 1-1.12 1.25H28.27A1.26 1.26 0 0 1 27 55.81v-25a1.25 1.25 0 0 1 2.49-.13v23.75h25.59V30.15a1.24 1.24 0 0 1 1.12-1.24Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M69.59 44.33a1.26 1.26 0 0 1 1.25 1.17v10.18a1.26 1.26 0 0 1-1.12 1.25H41.53a1.25 1.25 0 0 1-.13-2.49h26.94v-8.86a1.25 1.25 0 0 1 1.12-1.24ZM41.73 21.6a1.25 1.25 0 0 1 1-.07l.14.06L64.07 32a1.254 1.254 0 0 1-1 2.3H63L42.31 24.11l-19.9 10.1a1.25 1.25 0 0 1-1.61-.43l-.07-.12a1.24 1.24 0 0 1 .43-1.61l.12-.07Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M55.21 37.73a1.24 1.24 0 0 1 1.55-.62h.12l17.36 8.49a1.254 1.254 0 1 1-1 2.3h-.12l-17.34-8.5a1.25 1.25 0 0 1-.58-1.66Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M86.74 0a8.84 8.84 0 0 1 8.84 8.58v53.25A8.84 8.84 0 0 1 87 70.67H8.84A8.84 8.84 0 0 1 0 62.09V8.84A8.85 8.85 0 0 1 11.42.38a1.25 1.25 0 0 1 .88 1.12v53.07a1.25 1.25 0 0 1-1.3 1.25 1.34 1.34 0 0 1-.35 0 5.78 5.78 0 0 0-1.84-.27 6.341 6.341 0 0 0-.23 12.68h78.16a6.34 6.34 0 0 0 0-12.68 6.1 6.1 0 0 0-1.85.28 1.26 1.26 0 0 1-1.57-.85 1.85 1.85 0 0 1 0-.23V1.58a1.27 1.27 0 0 1 .88-1.2A9.05 9.05 0 0 1 86.74 0ZM8.84 2.5A6.35 6.35 0 0 0 2.5 8.61v47.06l.09-.09a8.78 8.78 0 0 1 6-2.58h1.23V2.57c-.21 0-.41 0-.62-.06Zm77.9 0h-1v50.55h1A8.82 8.82 0 0 1 93 55.58l.09.09V8.84A6.34 6.34 0 0 0 87 2.5Z"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M84.53 9.18v2.5H11.06v-2.5h73.47zM48.64 35.07H36v12.69h12.64Zm-2.5 2.5v7.69h-7.69v-7.69Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'BlueprintWithHouseIcon';

export default Icon;
